import React, { useState } from 'react';
import { Icons } from '../Icon.jsx';

const PrefabPanel = ({ primaryNode, prefabs, onOpenPrefab, onUpdatePrefab, onBreakPrefab }) => {
  const [isOpen, setIsOpen] = useState(false);
  const isPrefab = !!primaryNode.props?.prefabId;
  const isVirtual = !!primaryNode.isVirtual;

  if (!isPrefab && !isVirtual) return null;

  const targetInstanceId = isVirtual ? primaryNode.instanceId : primaryNode.id;
  const prefabId = primaryNode.props?.prefabId;
  const prefabDef = prefabs.find(p => p.id === prefabId);
  const prefabName = prefabDef?.name || 'Unknown Prefab';

  return (
    <div className="border-b border-admin_bordered">
      <div className="flex items-center bg-admin_canvas hover:bg-admin_neutral_1/10 transition-colors">
        <button
          className="flex-1 flex items-center justify-between p-3 text-left outline-none"
          onClick={() => setIsOpen(!isOpen)}
        >
          <div className="flex items-center gap-2">
            {isOpen ? <Icons.ChevronDown className="w-3.5 h-3.5" /> : <Icons.ChevronRight className="w-3.5 h-3.5" />}
            <Icons.BoxSelect className="w-3.5 h-3.5 text-blue-500" />
            <span className="text-xs font-semibold text-admin_text_secondary uppercase tracking-wider">Prefab</span>
          </div>
          <div className="text-sm text-admin_text font-medium truncate mr-2" title={prefabName}>
            {prefabName}
          </div>
        </button>
      </div>

      {isOpen && (
        <div className="p-4 bg-admin_paper">
          {/* Action Buttons */}
          <div className="flex gap-1.5">
          <button
            onClick={() => onOpenPrefab?.(prefabId)}
            className="flex-1 flex items-center justify-center gap-1.5 px-2 py-1.5 text-xs font-medium text-blue-600 bg-blue-50 hover:bg-blue-100 rounded transition-colors"
            title="Open base prefab in isolation"
          >
            <Icons.ExternalLink className="w-3 h-3" />
            Open
          </button>
          <button
            onClick={() => onUpdatePrefab?.(targetInstanceId)}
            className="flex-1 flex items-center justify-center gap-1.5 px-2 py-1.5 text-xs font-medium text-green-600 bg-green-50 hover:bg-green-100 rounded transition-colors"
            title="Apply current changes to base prefab"
          >
            <Icons.Upload className="w-3 h-3" />
            Update
          </button>
          <button
            onClick={() => onBreakPrefab?.(targetInstanceId)}
            className="flex-1 flex items-center justify-center gap-1.5 px-2 py-1.5 text-xs font-medium text-red-600 bg-red-50 hover:bg-red-100 rounded transition-colors"
            title="Unlink from base prefab"
          >
            <Icons.Remove className="w-3 h-3" />
            Break
          </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default PrefabPanel;
